import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FormState {
  isPartShippingSubmitting: boolean;
  isFormPartShippingValid: boolean;
  formPartShippingAddressData: any;
}

const initialState: FormState = {
  isPartShippingSubmitting: false,
  isFormPartShippingValid: false,
  formPartShippingAddressData: {},
};

const formPartShippingAddressSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    triggerPartShippingAddressSubmit: (state) => {
      state.isPartShippingSubmitting = true;
    },

    setPartShippingAddressFormValidity: (state, action: PayloadAction<{ isValid: boolean; formData: any }>) => {
      state.isFormPartShippingValid = action.payload.isValid;
      state.formPartShippingAddressData = action.payload.formData;
      state.isPartShippingSubmitting = false;
    },

    resetFormPartShippingAddressData: (state) => {
      state.isPartShippingSubmitting = false;
      state.isFormPartShippingValid = false;
      state.formPartShippingAddressData = {};
    },
  },
});

export const { setPartShippingAddressFormValidity, triggerPartShippingAddressSubmit, resetFormPartShippingAddressData } = formPartShippingAddressSlice.actions;
export default formPartShippingAddressSlice.reducer;
